(function ($){
    $(document).ready(function (){
    
     
   
      
        // Hover Header
      	$('.site-nav__expanded-item, .site-nav').mouseenter(function(){
            $('.site-header-sticky').addClass('hovered');
        });
      
      	$('.site-nav').mouseleave(function(){
          setTimeout(function(){
              $('.site-header-sticky').removeClass('hovered');
          }, 350);
        });
     
        // Description Layouts
        function fullDescriptionLayout(){

            $("#descriptionTabs").tabs();

            $("#descriptionAccordion").accordion({
                heightStyle: "content",
                collapsible: true
            });

            // Scroll to div
            $(".tabs-information a").click(function() {
                $('html,body').animate({ scrollTop: $(".tabbed").offset().top-100 }, 'slow' );
            });
            
        }

        fullDescriptionLayout();

        if (Shopify.designMode) {
            document.addEventListener('shopify:section:load', function() {
                fullDescriptionLayout();
            });
        }        

    });
})(jQuery);